var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265137,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 39.8125C46.1281 39.8125 45.8363 39.8125 45.5851 39.8294C41.9716 40.073 39.0959 42.8656 38.8451 46.3746C38.8276 46.6186 38.8276 46.902 38.8276 47.4044V47.4646C38.8276 47.967 38.8276 48.2504 38.8451 48.4944C39.0959 52.0032 41.9716 54.796 45.5851 55.0395C45.8363 55.0565 46.1281 55.0565 46.6455 55.0565H47.8848C48.4021 55.0565 48.694 55.0565 48.9451 55.0395C49.9036 54.9749 50.8111 54.7306 51.6314 54.341L55.5261 55.4375L54.5024 51.8899C55.173 50.9041 55.5959 49.7442 55.6853 48.4944C55.7026 48.2504 55.7026 47.9669 55.7026 47.4646V47.4044C55.7026 46.902 55.7026 46.6186 55.6853 46.3746C55.4344 42.8656 52.5586 40.073 48.9451 39.8294C48.694 39.8125 48.4021 39.8125 47.8848 39.8125H46.6455Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1914 28.5889C43.8099 28.5625 43.3666 28.5625 42.5811 28.5625H40.6991C39.9136 28.5625 39.4704 28.5625 39.0889 28.5889C33.6019 28.9689 29.235 33.3254 28.8541 38.7994C28.8276 39.18 28.8276 39.6221 28.8276 40.4058V40.4998C28.8276 41.2834 28.8276 41.7255 28.8541 42.1061C28.9898 44.056 29.6318 45.8654 30.6502 47.4031L29.0956 52.9375L35.0099 51.2269C36.0594 51.7391 37.2027 52.0903 38.4072 52.2484C37.7776 51.1635 37.3811 49.9289 37.2865 48.6057C37.2651 48.3051 37.2651 47.9705 37.2651 47.521L37.2651 47.4646L37.2651 47.348C37.2651 46.8985 37.2651 46.5637 37.2865 46.2633C37.5954 41.9421 41.1239 38.5641 45.48 38.2705C45.7845 38.2499 46.1245 38.25 46.5905 38.25L46.6455 38.25L47.9398 38.25C48.4058 38.25 48.7458 38.2499 49.0503 38.2705C51.1249 38.4103 53.0119 39.2498 54.4526 40.5575C54.4526 40.5385 54.4526 40.5192 54.4526 40.4998V40.4058C54.4526 39.6221 54.4526 39.18 54.4261 38.7994C54.0453 33.3254 49.6784 28.9689 44.1914 28.5889Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/Assistance.e164b1c044042d12689dd7ba271480ed.svg";
export { ForwardRef as ReactComponent };